import { createContext, useContext, useEffect, FC } from 'react';
import { initializeAmplitude, logAmplitudeEvent, amplitudeData } from './amplitude';

const AmplitudeContext = createContext({ logAmplitudeEvent });

interface useAmplitudeInterface {
  logAmplitudeEvent: (eventName: string, data?: amplitudeData) => Promise<number>;
}

const AmplitudeProvider: FC = ({ children }) => {
  useEffect(() => {
    initializeAmplitude();
  }, []);
  return <AmplitudeContext.Provider value={{ logAmplitudeEvent }}>{children}</AmplitudeContext.Provider>;
};

const useAmplitude = (): useAmplitudeInterface => {
  const context = useContext(AmplitudeContext);
  return context;
};

export { AmplitudeProvider, useAmplitude };
